import {BaseDomainDataSource} from "../../../../infrastructure/models/base-domain-data-source";
import {PropositionBetsDetailsDomainModel} from "./proposition-bets.details.domain-model";
import type {PartialGameDomainModel} from "../../../partial-game/models/partial-game-domain-model";
import type {AthleteDomainModel} from "../../../common/athlete/athlete-domain-model";
import {PropositionBetsDetailsResponseApiModel} from "./proposition-bets.details.response-api-model";
import {CompetitorDomainModel} from "../../../common/competitor/models/competitor-domain-model";
import {PropositionBetsDomainModel} from "../../proposition/models/proposition-bets.domain-model";
import {BookmakerDomainModel} from "../../../common/bookmaker/models/bookmaker-domain-model";

export class PropositionBetsDetailsDataSource extends BaseDomainDataSource {
  propsRecordTable: PropositionBetsDetailsDomainModel;
  competitors: Map<Number, CompetitorDomainModel>;
  games: Array<PartialGameDomainModel>;
  athlete: AthleteDomainModel;

  constructor(
    model: PropositionBetsDetailsResponseApiModel,
    propsRecordTable: PropositionBetsDetailsDomainModel,
    propositionBets: Array<PropositionBetsDomainModel>,
    competitors: Map<Number, CompetitorDomainModel>,
    games: Array<PartialGameDomainModel>,
    athlete: AthleteDomainModel,
    bookmakers: Array<BookmakerDomainModel>
  ) {
    super(model);

    this.propsRecordTable = propsRecordTable;
    this.propositionBets = propositionBets;
    this.competitors = competitors;
    this.games = games;
    this.athlete = athlete;
    this.recordsText = model.recordsText;
    this.bookmakers = bookmakers;
  }
}